import { useRecoilValue } from 'recoil'
import { PartnerListData } from 'src/recoil/common'
import { PartnerListType } from 'src/types/type'
import { LegacyRef } from 'react'
import { BannerWrap } from 'src/styles/styledcomponent/views/Rop02/Banner'

interface BannerProps {
  banner1Ref: LegacyRef<HTMLImageElement>
  banner2Ref: LegacyRef<HTMLImageElement>
}
const Banner = ({ banner1Ref, banner2Ref }: BannerProps): JSX.Element => {
  const PartnerData: PartnerListType = useRecoilValue(PartnerListData)
  const { Image1, Image2 } = PartnerData

  // 개발기에는 이미지가 존재하지 않습니다.
  return (
    <BannerWrap>
      <img ref={banner1Ref} src={`https://img.familycare.ai${Image1}`} alt="배너1" />
      <img ref={banner2Ref} src={`https://img.familycare.ai${Image2}`} alt="배너2" />
    </BannerWrap>
  )
}
export default Banner
